import { render, staticRenderFns } from "./RulesTable.vue?vue&type=template&id=356ad286&"
import script from "./RulesTable.vue?vue&type=script&lang=js&"
export * from "./RulesTable.vue?vue&type=script&lang=js&"
import style0 from "./RulesTable.vue?vue&type=style&index=0&id=356ad286&prod&lang=css&"
import style1 from "./RulesTable.vue?vue&type=style&index=1&id=356ad286&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports